<script>
import moment from 'moment'

export default {
  methods: {
    async setLoginData(tokenObject) {
      this.$store.dispatch('setLogin', tokenObject)

      await this.$store.dispatch('getOrganizationStructure', {
        organizationId: tokenObject.account.organization._id,
      })

      const defaultLang = navigator.language || navigator.userLanguage
      const language =
        tokenObject?.account?.language || defaultLang.substring(0, 2)

      this.$i18n.i18next.changeLanguage(language)

      let safeLanguage = language
      // This conditions are needed because moment doesn't support 'zh' without a dialect and doesn't support 'zu' so we added a fallback to english instead.
      if (language.includes('zh')) safeLanguage = 'zh-cn'
      if (language.includes('zu')) safeLanguage = 'en'

      moment.locale(safeLanguage)

      this.$resetTracking()
      this.$configureTracking()

      this.$track('session.Start', this.$store, {
        process: 'loginResponse',
        status: 'success',
      })
    },
  },
}
</script>
